module.exports = __webpack_public_path__ + "img/2078b7b9-e5ad-40b5-b4f1-7019d64cf83e.cadd1361.png";